import { AnswerSelectContainerProps }  from '../config';
import { FC } from 'react';
import { observer } from 'mobx-react';
import { useStores } from '../../../../hooks/useStores';

const _ContainDefault: FC<AnswerSelectContainerProps> = ({
  question,
  onPress,
  children,
}) => {
  const { question: qstore } = useStores();
  const loading = !qstore.isReady(question._id);
  return children({
    answers: question.answers,
    questionId: question._id,
    questionKey: question.key,
    onPress,
    loading,
  });
};

export const ContainDefault = observer(_ContainDefault);

